import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import PageSearch from '../../search/PageSearch';

export default function FormInputPageSearch(props) {
  return <FormInputSearch {...props} searchComponent={PageSearch} />;
}
